import { Box, ListItem, ListItemText, List, Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  Paper,
  TestDataAttribute,
} from '@roc/ui';
import { observer } from 'mobx-react';
import { sanitizeTestId } from '@roc/feature-utils';
import { usePayoffRequestStore } from '../hooks/usePayoffRequestStore';
import { useLoanStore } from '@roc/feature-loans-shared';
import { formatCurrency } from '@roc/ui/utils';
import { RequestPayoffButton } from './requestPayoffButton';

const useStyles = makeStyles(theme => ({
  helperTextColor: {
    color: theme.palette.grey[500]
  },
  helperText: {
    color: theme.palette.grey[500],
    fontSize: '12px',
  },
}));

const listItem = (label, value, helperText = null, icon = null, customTestId = null) => {
  const classes = useStyles();
  const testId = sanitizeTestId(customTestId || label);
  return (
    <ListItem>
      <ListItemText>
        <Box display="flex">
          {icon && <Box ml={1}>{icon}</Box>}
          <Box flexGrow={1} display="flex">{label}</Box>
          <TestDataAttribute id={testId}>
            <Box>{value}</Box>
          </TestDataAttribute>
        </Box>
        {helperText && <Box flexGrow={1} className={classes.helperText}>{helperText}</Box>}
      </ListItemText>
    </ListItem>
  );
};

const divider = <Divider variant="middle" component="li" />;


export const PayoffKeyLoanInformation = observer(() => {
  const classes = useStyles();

  const { loanStore: { loanDetails } } = useLoanStore();
  const { payoffRequestStore: { currentPayoff } } = usePayoffRequestStore();

  return (
    <Paper title="Key Loan Information">
      <Box>
        <List>
          {divider}
          {listItem('Initial Loan Amount', formatCurrency(loanDetails?.initialLoanAmount) ?? '-')}
          {divider}
          {listItem('CEMA', currentPayoff?.cema ? 'Yes' : '-')}
          {divider}
          {listItem('Servicer', loanDetails?.servicer ?? '-')}
          {divider}
          {listItem('Maturity Date', loanDetails.maturityDate ?? '-')}
          {divider}
          {listItem(
            <>
              <Box>Unpaid Principal Balance*</Box>
              <Box className={classes.helperTextColor}>(as of 04/30/2025)</Box>
            </>,
            formatCurrency(loanDetails?.calculatedLoanData?.fundedAmount) ?? '-', '*Excludes any fees associated with payoff')}
          {divider}
          <ListItem>
            <Box display="flex" justifyContent='flex-end' width='100%'>
              <RequestPayoffButton />
            </Box>
          </ListItem>
        </List>
      </Box>
    </Paper>
  )
});